import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67c7cf5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute top-4 left-4 flex gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "px-2 py-1 text-xs font-medium bg-primary-700 text-white rounded-full"
}
const _hoisted_3 = {
  key: 1,
  class: "px-2 py-1 text-xs font-medium bg-accent-600 text-white rounded-full"
}
const _hoisted_4 = { class: "flex items-center gap-2 mb-3" }
const _hoisted_5 = { class: "text-xs font-medium text-primary-500" }
const _hoisted_6 = { class: "text-lg font-heading font-semibold text-primary-800 mb-2 pr-16" }
const _hoisted_7 = { class: "text-sm text-primary-600 mb-4 line-clamp-2" }
const _hoisted_8 = { class: "flex items-center gap-3 mb-4" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "w-8 h-8 rounded-full bg-primary-200 flex items-center justify-center"
}
const _hoisted_11 = { class: "text-xs font-medium text-primary-700" }
const _hoisted_12 = { class: "text-sm text-primary-600" }
const _hoisted_13 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_14 = { class: "flex justify-between text-xs text-primary-500 mb-1" }
const _hoisted_15 = { class: "h-2 bg-primary-100 rounded-full overflow-hidden" }
const _hoisted_16 = { class: "flex items-center justify-between pt-3 border-t border-primary-100" }
const _hoisted_17 = { class: "flex items-center gap-4 text-sm text-primary-500" }
const _hoisted_18 = { class: "flex items-center gap-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
  })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-medium text-accent-600" }, " View Details ", -1))

import { PropType, computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  proposal: {
    type: Object as PropType<ProposalListItem>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const categoryLabels: Record<ProposalCategory, string> = {
  maintenance: "Maintenance",
  improvement: "Improvement",
  policy: "Policy",
  event: "Event",
  financial: "Financial",
  other: "Other",
};

const categoryColors: Record<ProposalCategory, string> = {
  maintenance: "bg-amber-100 text-amber-800",
  improvement: "bg-accent-100 text-accent-800",
  policy: "bg-blue-100 text-blue-800",
  event: "bg-purple-100 text-purple-800",
  financial: "bg-emerald-100 text-emerald-800",
  other: "bg-primary-100 text-primary-800",
};

const statusLabels: Record<ProposalStatus, string> = {
  draft: "Draft",
  gathering_support: "Gathering Support",
  ready_for_vote: "Ready for Vote",
  voting: "Voting",
  approved: "Approved",
  rejected: "Rejected",
};

const statusDotColors: Record<ProposalStatus, string> = {
  draft: "bg-primary-400",
  gathering_support: "bg-amber-500",
  ready_for_vote: "bg-accent-500",
  voting: "bg-blue-500",
  approved: "bg-green-500",
  rejected: "bg-red-500",
};

const categoryLabel = computed(() => categoryLabels[props.proposal.category]);
const categoryClass = computed(() => categoryColors[props.proposal.category]);
const statusLabel = computed(() => statusLabels[props.proposal.status]);
const statusDotClass = computed(() => statusDotColors[props.proposal.status]);

const progressPercent = computed(() => {
  if (props.proposal.support_threshold === 0) return 100;
  return Math.min(
    100,
    (props.proposal.support_count / props.proposal.support_threshold) * 100
  );
});

const friendlyDate = computed(() => {
  const today = new Date();
  const date = new Date(props.proposal.created_on);
  const delta = Math.round((today.getTime() - date.getTime()) / 1000);
  const minute = 60;
  const hour = minute * 60;
  const day = hour * 24;

  if (delta < 30) return "just now";
  if (delta < minute) return `${delta} seconds ago`;
  if (delta < 2 * minute) return "a minute ago";
  if (delta < hour) return `${Math.floor(delta / minute)} minutes ago`;
  if (Math.floor(delta / hour) === 1) return "1 hour ago";
  if (delta < day) return `${Math.floor(delta / hour)} hours ago`;
  if (delta < day * 2) return "yesterday";
  return `${Math.floor(delta / day)} days ago`;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: `/proposals/${__props.proposal.id}`,
    class: "relative block p-6 overflow-hidden bg-white border border-primary-200 rounded-xl shadow-soft hover:shadow-card-hover hover:-translate-y-1 transition-all duration-200 cursor-pointer"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", {
        class: _normalizeClass(["absolute top-4 right-4 px-3 py-1 text-xs font-medium uppercase tracking-wide rounded-full", _unref(categoryClass)])
      }, _toDisplayString(_unref(categoryLabel)), 3),
      _createElementVNode("div", _hoisted_1, [
        (__props.proposal.is_author)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " Your Proposal "))
          : (__props.proposal.is_supporting)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Supporting "))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", {
          class: _normalizeClass(["w-2 h-2 rounded-full", _unref(statusDotClass)])
        }, null, 2),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(statusLabel)), 1)
      ]),
      _createElementVNode("h3", _hoisted_6, _toDisplayString(__props.proposal.title), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(__props.proposal.description), 1),
      _createElementVNode("div", _hoisted_8, [
        (__props.proposal.author.profile)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: __props.proposal.author.profile,
              class: "w-8 h-8 rounded-full object-cover",
              alt: ""
            }, null, 8, _hoisted_9))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(__props.proposal.author.first_name.charAt(0)) + _toDisplayString(__props.proposal.author.last_name.charAt(0)), 1)
            ])),
        _createElementVNode("span", _hoisted_12, _toDisplayString(__props.proposal.author.first_name) + " " + _toDisplayString(__props.proposal.author.last_name), 1)
      ]),
      (__props.proposal.status === 'gathering_support')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", null, _toDisplayString(__props.proposal.support_count) + " supporters", 1),
              _createElementVNode("span", null, _toDisplayString(__props.proposal.support_threshold) + " needed", 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", {
                class: "h-full bg-accent-500 rounded-full transition-all duration-300",
                style: _normalizeStyle({ width: _unref(progressPercent) + '%' })
              }, null, 4)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, [
            _hoisted_19,
            _createTextVNode(" " + _toDisplayString(__props.proposal.comment_count), 1)
          ]),
          _createElementVNode("span", null, _toDisplayString(_unref(friendlyDate)), 1)
        ]),
        _hoisted_20
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})